/*eslint-disable*/
import React from "react"
// nodejs library to set properties for components
import PropTypes from "prop-types"
// nodejs library that concatenates classes
import classNames from "classnames"
import { withStyles } from "@material-ui/core"
import footerStyle from "../../assets/jss/material-kit-react/components/footerStyle.jsx"
import GridItem from "../Grid/GridItem"
import GridContainer from "../Grid/GridContainer"
import ScrollableAnchor from "react-scrollable-anchor"
import Hidden from "@material-ui/core/Hidden"

// @material-ui/icons

class FooterSecond extends React.Component {
    state = {
        termsOpened: false,
        privacyOpened: false,
        faqOpened: false,
    }

    handlePopoverClosed = (e, type) => {
        e.preventDefault()
        this.setState({
            [type]: false,
        })
    }

    render() {
        const { classes, whiteFont } = this.props
        const footerClasses = classNames({
            [classes.footerSecond]: true,
            [classes.footerWhiteFont]: whiteFont,
        })
        const aClasses = classNames({
            [classes.a]: true,
            [classes.footerWhiteFont]: whiteFont,
        })
        return (
            <footer
                className={footerClasses}
                style={{
                    backgroundColor: "#fff",
                    display: "flex",
                    textAlign: "center",
                }}>
                <ScrollableAnchor id="contact">
                    <div style={{ width: "100%" }}>
                        <div className={classes.center}>
                            <GridContainer>
                                {/* Only Large */}
                                <GridItem xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center" }}>
                                    <span
                                        style={{
                                            color: "rgb(102, 102, 102)",
                                            fontWeight: "300",
                                            fontSize: "0.8rem",
                                        }}>
                                        © 2022 Figure, Inc. — All Rights Reserved.
                                    </span>
                                </GridItem>
                            </GridContainer>
                        </div>
                    </div>
                </ScrollableAnchor>
            </footer>
        )
    }
}

FooterSecond.propTypes = {
    classes: PropTypes.object.isRequired,
    whiteFont: PropTypes.bool,
}

export default withStyles(footerStyle)(FooterSecond)



// WEBPACK FOOTER //
// ./src/components/Footer/FooterSecond.jsx